import { Pipe, PipeTransform } from '@angular/core'
import { AuditReportType } from '@wm-front/admin/graphql'

declare const $localize: any

@Pipe({
  name: 'auditReportType',
  standalone: true,
})
export class AuditReportTypePipe implements PipeTransform {
  /** Transform audit report type into localised string
   * @param { AuditReportType }
   * @returns { string }
   */
  public transform(value: AuditReportType, fullLength?: boolean): string {
    switch (value) {
      case AuditReportType.Periodique:
        if (fullLength) {
          return $localize`:Table cell label | Report type Periodical@@auditReportTypePipePeriodicFullLabel:Périodique`
        } else {
          return $localize`:Table cell label | Report type Periodical@@auditReportTypePipePeriodicLabel:Pér.`
        }
      case AuditReportType.Quinquennal:
        if (fullLength) {
          return $localize`:Table cell label | Report type Quinquennal@@auditReportTypePipeQuinquennialFullLabel:Quinquennal`
        } else {
          return $localize`:Table cell label | Report type Quinquennal@@auditReportTypePipeQuinquennialLabel:Quinq.`
        }
      case AuditReportType.Audit:
        return $localize`:Table cell label | Report type Audit@@auditReportTypePipeAuditLabel:Audit`
      case AuditReportType.Insurance:
        if (fullLength) {
          return $localize`:Table cell label | Report type Audit@@auditReportTypePipeInsuranceFullLabel:Insurance Company`
        } else {
          return $localize`:Table cell label | Report type Audit@@auditReportTypePipeInsuranceLabel:Insurance Co.`
        }
      default:
        return ''
    }
  }
}
